
import { Component, Vue, Ref } from "vue-property-decorator";
import t from "@common/src/i18n/t";
import { namespace } from "vuex-class";

const common_warranty = namespace("common_warranty");
const base = namespace("base");

@Component({})
export default class AuditDialog extends Vue {
  @common_warranty.Action claimsApplyAudit;
  @base.Action getDictionaryList;

  @Ref("form") form;

  show = false;
  applyNo = "";
  open(applyNo) {
    this.show = true;
    this.applyNo = applyNo;
    this.formData.claimFaultReason = "";
    this.formData.claimType = "";
    this.formData.approved = "1";
    this.formData.auditRemark = "";
    this.formData.payoutAmount = "";
    (this.$refs.form as any).clearValidate();
  }
  async handleConfirm() {
    try {
      await this.form.validate();
      this.claimsApplyAudit({
        ...this.formData,
        applyNo: this.applyNo
      }).then(() => {
        this.$message.success(t("v3_7_6.audit-completed"));
        this.show = false;
        this.$emit("auditDone");
      });
    } catch (e) {
      //
    }
  }

  formData: any = {
    claimFaultReason: "",
    claimType: "",
    approved: "1",
    auditRemark: "",
    payoutAmount: ""
  };
  formDataRules: any = {
    claimFaultReason: { required: true, message: t("v210831.please-select") },
    approved: { required: true, message: t("v210831.please-select") },
    claimType: { required: true, message: t("v210831.please-select") },
    auditRemark: { required: true, message: t("base.please-input") },
    payoutAmount: [{ required: true, message: t("base.please-input") }]
  };
  faultReasonList = [];
  claimTypeList = [];
  created() {
    this.getDictionaryList("claim_fault_reason_type").then(data => {
      this.faultReasonList = data;
    });
    this.getDictionaryList("warranty_claim_type").then(data => {
      this.claimTypeList = data;
    });
  }
}
